export const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80%',
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius: '12px',
    boxShadow: 24,
    p: 4,
    overflow: 'auto'
};